import { render } from "./HorizontalNavMenu.vue?vue&type=template&id=5df8903e"
import script from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenu.vue?vue&type=script&lang=js"

import "./HorizontalNavMenu.vue?vue&type=style&index=0&id=5df8903e&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__